export default __webpack_public_path__ + "static/media/docs-stress-resistant-man.8a8762eb.png";